import db from "./db.js"
import {Notify} from 'vant'
import i18n from "utils/i18n";

const util = {}
util.getLanguage = () => {
    return db.get("sys.public.language.value").value() || "zh"
}
util.getConfig = () => {
    return window.WIN_GLOBAL ? {...process.env, ...window.WIN_GLOBAL} : process.env
}
util.getIpUrl = function (vue) {
    let url = location.href.replace(vue.$route.path, "")
    let index = url.indexOf("?")
    if (index > -1) {
        return url.substr(0, index)
    }
    return url
}

/**
 * 判断是否为空
 * @param {*} val
 */
util.isEmpty = function (val) {
    if (val instanceof Array) {
        if (val.length === 0) return true
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === "{}") return true
    } else {
        if (val == null || val === undefined || val === "") return true
        return false
    }
    return false
}

/**
 * 判断是否不为空
 * @param {*} val
 */
util.isNotEmpty = function (val) {
    return !util.isEmpty(val) && val !== undefined && val !== null
}

/**
 * 判断是否企业微信
 */
util.isWxWorkBrowser = function () {
    const ua = window.navigator.userAgent.toLowerCase()
    //通过正则表达式匹配ua中是否含有wxwork字符串
    if (ua.match(/wxwork/i) == "wxwork") {
        return true
    } else {
        return false
    }
}

/**
 * 判断是否为微信浏览器
 */
util.isWeChatBrowser = function () {
    const ua = window.navigator.userAgent.toLowerCase()
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true
    } else {
        return false
    }
}

/**
 * 获取年月日
 */
util.getDay = function getDay(next = 0) {
    let date = new Date();
    if (next !== 0) {
        date.setTime(date.getTime() + next * 24 * 60 * 60 * 1000);
    }
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return year + "-" + month + "-" + day;
}

util.downLoad = function (res, errInfo = '文件不存在。') {
    let d = res.data
    if (d.type === 'application/json') {
        Notify({
            type: 'danger',
            message: errInfo || i18n.t('error.network')
        })
    } else {
        const type = res.headers['content-type'] || 'text/html'
        let disposition = res.headers['content-disposition']
        const content = res.data
        if (content.type === 'text/html' && res.request && res.request.responseURL) {
            window.open(res.request.responseURL)
        } else {
            console.log("type",content.type);
            const fileName = decodeURI(disposition.split("filename=")[1], 'utf-8')
            const blob = content instanceof Blob ? content : new Blob([content], {type: type})
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            console.log("haha");
            window.URL.revokeObjectURL(link.href)
            console.log("link",link);
            document.body.removeChild(link)
        }
    }
}

util.getWordsCount = function (str) {
	if (util.isEmpty(str)) return 0;
	var strlength = str.length;
	var chinese = "";
	var symbol = "";
	if (!strlength) { //如果字符串长度为零，返回零
		return 0;
	}
	//匹配这些中文标点符号 。 ？ ！ ， 、 ； ： “ ” ‘ ' （ ） 《 》 〈 〉 【 】 『 』 「 」 ﹃ ﹄ 〔 〕 … — ～ ﹏ ￥
	var reg = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g;
	if (reg.test(str)) {
		symbol = str.match(reg);
	}

	if (/[\u4e00-\u9fa5]/.test(str)) {
		chinese = str.match(/[\u4e00-\u9fa5]/g);
	}
	var subStrLength = (strlength - chinese.length - symbol.length) / 2
	return Math.ceil(subStrLength) + chinese.length + symbol.length //计算字符个数
}

// 计算字符串长度(汉字和中文标点符号算两个字符长度，英文字母和数字算一个字符长度)
util.getStrLength = function (str) {
	if (util.isEmpty(str)) return 0;
	if (typeof str != "string") {
		str += "";
	}
	//let byts = store.state.system.chineseBytes
    let byts = 2
	if (byts === 2) {
		return str.replace(/[\u4e00-\u9fa5]/g, "01").length;
	} else if (byts === 3) {
		return str.replace(/[\u4e00-\u9fa5]/g, "012").length;
	}
}

export default util
